import { AuditFormDto } from './auditForm.dto';
import { AuditFormControlTypeDto } from './auditFormControlType.dto';
import { AuditFormQuestionOptionDto } from './auditFormQuestionOptions.dto';
import { AuditFormSectionDto } from './auditFormSection.dto';
import { BaseDto } from '../base.dto';

export class AuditFormQuestionDto extends BaseDto {
  auditForm: AuditFormDto;
  auditFormId?: number;
  text: string;
  controlTypeId: number;
  controlType: AuditFormControlTypeDto;
  guidance?: string;
  options?: AuditFormQuestionOptionDto[];
  sort?: number;
  isDeleted?: boolean;
  auditFormSection: AuditFormSectionDto;
  auditFormSectionId?: number;
}
